import React from "react";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import AddEditpage from "./addEditpage";

const CreateCall = () => {
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Create Call"
            title="Main"
            subtitle="Create Call"
            modalClass="col-auto float-end ms-auto"
          />
          <AddEditpage />
        </div>
      </div>
    </>
  );
};

export default CreateCall;
